import { useCallback, useEffect, useState } from "react";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { PLACEMENT_STATUS_LABELS, trackFeaturedPlacementEvent } from "../../../constants/automapFeaturedPlacementConstants";
import { fetchPlacementPerformance } from "../../../services/automapFeaturedPlacementApi";
import { AdminPlacementsNav } from "./AdminPlacementsShared";

export default function AdminPlacementPerformancePage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [city, setCity] = useState("");
  const [slot, setSlot] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchPlacementPerformance({ city: city || undefined, slot: slot || undefined });
      setRows(data.report || []);
      trackFeaturedPlacementEvent("admin_placement_performance_viewed");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [city, slot]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Destacados" title="Performance de placements" description="Impresiones, clics, WhatsApp y leads por placement." />
      <AdminAutomotiveNav active="placements" />
      <AdminPlacementsNav active="performance" />
      <main className="admin-console__main wrap">
        <div className="dealer-inventory-toolbar">
          <input placeholder="Ciudad" value={city} onChange={(e) => setCity(e.target.value)} />
          <input placeholder="Slot" value={slot} onChange={(e) => setSlot(e.target.value)} />
          <button type="button" className="admin-btn admin-btn--primary" onClick={load}>Filtrar</button>
        </div>
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading ? (
          <div className="import-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Placement</th>
                  <th>Dealer</th>
                  <th>Listing</th>
                  <th>Slot</th>
                  <th>Estado</th>
                  <th>Imp.</th>
                  <th>Clics</th>
                  <th>CTR</th>
                  <th>Detalle</th>
                  <th>WhatsApp</th>
                  <th>Leads</th>
                  <th>Conv.</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row) => (
                  <tr key={row.placementId}>
                    <td>{row.placementName}</td>
                    <td>{row.dealerName}</td>
                    <td>{row.listingTitle || "—"}</td>
                    <td>{row.slotKey}</td>
                    <td>{PLACEMENT_STATUS_LABELS[row.status] || row.status}</td>
                    <td>{row.impressions ?? 0}</td>
                    <td>{row.clicks ?? 0}</td>
                    <td>{row.clickThroughRate != null ? `${row.clickThroughRate}%` : "—"}</td>
                    <td>{row.vehicleDetailViews ?? 0}</td>
                    <td>{row.whatsappClicks ?? 0}</td>
                    <td>{row.leads ?? 0}</td>
                    <td>{row.leadConversionRate != null ? `${row.leadConversionRate}%` : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
